// Trailing slashes are not significant for our route comparison, so `/board/a`
// and `/board/a/` are treated as the same location.
const normalizePathname = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

/**
 * Decide whether to block an in-app navigation away from a board so we can save
 * first. Blocks only when there are unsaved changes AND we're actually leaving
 * the current board (the pathname changes). Same-pathname navigations — a query
 * or router-state change while staying on the board — never block. Comparison
 * is pathname-only and makes no route-prefix assumptions, so it covers every
 * board route uniformly (e.g. /board/:id).
 */
export const shouldBlockNavigation = (
  currentPathname: string,
  nextPathname: string,
  hasUnsavedChanges: boolean,
): boolean => {
  if (!hasUnsavedChanges) return false
  return normalizePathname(currentPathname) !== normalizePathname(nextPathname)
}
